
import Icon from '@/components/UntitledUI/Icon.vue'
import Checkbox from '@/components/UntitledUI/Checkbox.vue'
import InputField from '@/components/UntitledUI/InputField.vue'
import Badge from '@/components/UntitledUI/Badge.vue'
import Tippy from '@/components/common/Tippy.vue'
import SearchFilter from '@/components/Search/Filtering/SearchFilter.vue'
import Button from '@/components/UntitledUI/Button.vue'
import { debounce } from 'lodash'

const MAX_KEEP_VALUES = 30

export default {
    name: 'TextSearchFilter',
    components: {
        SearchFilter,
        InputField,
        Icon,
        Checkbox,
        Button,
        Badge,
        Tippy
    },
    props: {
        tag: {
            type: Object,
            required: true
        },
        mainTag: {
            type: Object,
            required: true
        },
        isActive: {
            type: Boolean,
            default: false
        },
        selectedFilters: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            cancelTokenSource: null,
            values: null,
            queryText: '',
            allLoaded: false,
            loading: false,
            searching: false,
            loadMoreDebounced: null,
            inputDropdownValue: this.selectedValues ?? []
        }
    },
    computed: {
        selectValues () {
            return this.values || []
        },
        selectedValues () {
            return (this.selectedFilters[this.tag.keyId] ?? [])
        },
        selectedLabels () {
            return this.selectedValues
        },
        searchTags () {
            return this.$route.query.tags ? (Array.isArray(this.$route.query.tags) ? this.$route.query.tags : [this.$route.query.tags]) : []
        },
        empty () {
            return Array.isArray(this.values) && this.values.length === 0
        }
    },
    watch: {
        selectedValues: {
            handler (values) {
                this.inputDropdownValue = values?.map(v => v.id) ?? []
            },
            immediate: true
        },
        queryText () {
            this.values = null
            this.allLoaded = false
            this.searching = true
            if (typeof this.loadMoreDebounced === 'function') {
                this.loadMoreDebounced()
            }
        },
        'tag.values' () {
            this.init()
        }
    },
    created () {
        this.loadMoreDebounced = debounce(this.loadMore, 400)
        this.init()
    },
    methods: {
        init () {
            if (Array.isArray(this.tag.values)) {
                this.queryText = ''
                this.values = this.tag.values
                this.allLoaded = typeof this.tag?.total === 'number' && this.tag.values.length >= this.tag.total
            }
            this.loadMoreDebounced = debounce(this.loadMore, 500)
        },
        loadMore () {
            // cancel previous requests if any
            if (this.cancelTokenSource !== null) {
                this.cancelTokenSource.cancel()
            }
            this.cancelTokenSource = this.$axios.CancelToken.source()
            this.loading = true
            const params = {
                key: this.tag.keyId,
                offset: this.values?.length || 0,
                query: this.queryText?.trim() || undefined,
                main: this.mainTag.id,
                tags: this.searchTags
            }
            return this.$axios.$get('/v1/search-tags', {
                cancelToken: this.cancelTokenSource.token,
                params
            }).then((res) => {
                this.values = (this.values || []).concat(res.items)
                if (res.items.length < res.perPage) {
                    this.allLoaded = true
                }
                this.loading = false
            }).finally(() => { this.searching = false; this.loading = false; this.cancelTokenSource = null })
        },
        toggleValue (checked, value) {
            if (checked) {
                this.inputDropdownValue.push(value)
                this.addFilter(value)
            } else {
                const index = this.inputDropdownValue.indexOf(value)
                if (index !== -1) {
                    this.inputDropdownValue.splice(index, 1)
                    this.removeFilter(value)
                }
            }
        },
        addFilter (tagId) {
            this.$emit('add-filter', tagId)
        },
        removeFilter (tagId) {
            this.$emit('remove-filter', tagId)
        },
        clear () {
            this.resetValues()
        },
        reset () {
            this.$emit('reset', this.inputDropdownValue)
            this.inputDropdownValue = []
        },
        resetValues () {
            if (Array.isArray(this.values) && this.values.length > MAX_KEEP_VALUES) {
                this.values = this.values.slice(0, MAX_KEEP_VALUES)
                this.allLoaded = false
            }
        }
    }
}
